module.exports = __webpack_public_path__ + "img/analysis-icon.0eb14b1a.svg";